<template>
  <div class="action-wrapper">
    <div class="go-dropdown-button" @click="dropdownActive = !dropdownActive" v-click-outside="actionDropdownOutsideClick">
      {{ placeholder }}
      <img src="@/assets/images/arrowdown.svg" class="dropdown-arrow" :class="dropdownActive && 'arrow-up'"/>
    </div>

    <div class="action-dropdown right" v-if="dropdownActive">
      <div
          class="action-list"
          v-for="(action, index) in actions"
          :key="index"
          @click="!action.pop && onAction(action.action)"
          @mouseenter="action.pop && startPopupTimer(index)"
          @mouseleave="action.pop && clearPopupTimer(index)"
          :class="{ 'has-popup': action.pop }"
      >
        <img v-if="action.pop && !popDirection" src="@/assets/images/arrowLeft.svg" class="popup-arrow-left"/>
        <span>{{ action.name }}</span>
        <img v-if="action.pop && popDirection" src="@/assets/images/arrowLeft.svg" class="popup-arrow-right"/>

        <!-- Secondary dropdown for popup actions -->
        <div
            v-if="action.pop && activePopupIndex === index"
            class="popup-dropdown"
            :class="{ 'popup-left': !popDirection }"
        >
          <div
              class="popup-item"
              v-for="(popItem, popIndex) in action.popupItems"
              :key="popIndex"
              @click="onPopupAction(popItem.action, action.action)"
          >
            <span>{{ popItem.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Actions'
    },
    actions: {
      type: Array,
      default: () => [
        {
          name: 'Action 1',
          action: '01'
        },
        {
          name: 'Action 2',
          action: '02',
          pop: true,
          popupItems: [
            { name: 'Sub Action 1', action: 'sub01' },
            { name: 'Sub Action 2', action: 'sub02' }
          ]
        }
      ]
    },
    onAction: {
      type: Function,
      default: () => {}
    },
    onPopupAction: {
      type: Function,
      default: () => {}
    },
    popDirection: {
      type: Boolean,
      default: true // true: right, false: left
    }
  },
  data() {
    return {
      dropdownActive: false,
      activePopupIndex: null,
      popupTimer: null
    }
  },
  methods: {
    actionDropdownOutsideClick() {
      this.dropdownActive = false;
      this.activePopupIndex = null;
    },
    startPopupTimer(index) {
      this.clearPopupTimer();
      this.popupTimer = setTimeout(() => {
        this.activePopupIndex = index;
      }, 200);
    },
    clearPopupTimer() {
      if (this.popupTimer) {
        clearTimeout(this.popupTimer);
        this.popupTimer = null;
      }
      this.activePopupIndex = null;
    }
  },
  beforeDestroy() {
    this.clearPopupTimer();
  }
}
</script>

<style scoped>
.action-wrapper {
  position: relative;
}

.go-dropdown-button {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  border-radius: 12px;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.action-dropdown {
  position: absolute;
  background-color: #f1f1f1;
  padding: 10px;
  border-radius: 8px;
  top: 40px;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 99999;
}

.action-list {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  position: relative;
}

.action-list:hover {
  background: #ffffff;
}

.action-list.has-popup {
  padding-right: 25px;
  padding-left: 25px;
}

.dropdown-arrow {
  transition: transform 0.3s;
}

.arrow-up {
  transform: rotate(180deg);
}

.popup-arrow {
  width: 12px;
  height: 12px;
  opacity: 0.6;
  position: absolute;
  right: 10px;
}

.popup-arrow-left {
  width: 12px;
  height: 12px;
  opacity: 0.6;
  position: absolute;
  left: 10px;
}

.popup-arrow-right {
  width: 12px;
  height: 12px;
  opacity: 0.6;
  position: absolute;
  right: 10px;
  transform: rotate(180deg);
}

.popup-dropdown {
  position: absolute;
  left: calc(100%);
  top: 0;
  background-color: #f1f1f1;
  padding: 10px;
  border-radius: 8px;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 100000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 300px;
  overflow-y: scroll;
}

.popup-dropdown.popup-left {
  left: auto;
  right: calc(100%);
}

.popup-item {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  border-radius: 8px;
  white-space: nowrap;
}

.popup-item:hover {
  background: #ffffff;
}
</style>
